// extracted by mini-css-extract-plugin
module.exports = {"bannerPcContainer":"pc_bannerPcContainer__k_xIP","image":"pc_image__2PMT9"};